import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { fetchCardItem } from './card.actions';
import { initialState } from './card.inital-state';

export const cardSlice = createSlice({
  name: 'card',
  initialState,
  reducers: {
    setVisibleReview(state, action: PayloadAction<boolean>) {
      state.visibleReview = action.payload;
    },
    setVisibleInnerReview(state, action: PayloadAction<boolean>) {
      state.visibleInnerReview = action.payload;
    },
    setLoadingAddToCard(state, action: PayloadAction<boolean>) {
      state.loadingAddToCard = action.payload;
    },
    setLoadingAddToFavorite(state, action: PayloadAction<boolean>) {
      state.loadingAddToFavorite = action.payload;
    },
    setLoadingRemoveCard(state, action: PayloadAction<boolean>) {
      state.loadingRemoveCard = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCardItem.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCardItem.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.catalog_item = payload.catalog_item;
        state.page_description = payload.page_description;
        state.navigation = payload.navigation;
      })
      .addCase(fetchCardItem.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
export const cardActions = cardSlice.actions;
export const { reducer } = cardSlice;
